var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { staticClass: "list-group list-group-flush mb-2" }, [
    _c("li", { staticClass: "list-group-item activity-item py-3 bt-0" }, [
      _c("div", { staticClass: "row align-items-center" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col comment-section" }, [
          _c("h6", { staticClass: "text-light-gray activity-title mb-0" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("global.search.noResults")) +
                ".\n        "
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pr-0 img col-auto" }, [
      _c("img", {
        staticClass: "img-fluid rounded-circle lg activity-avatar",
        attrs: {
          src: require("@Shared/@Assets/img/user-male-placeholder.png"),
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }